var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('pre',[_c('p',[_c('a',{attrs:{"href":_vm.message.payload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.message.payload.filename || _vm.message.payload.url.split('#').pop()))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }